import { Injectable } from '@angular/core';
import { CertPerfDataUpsertRequest, CertPerfDataUpsertResponse } from '../models/engineering-view-models';
import { HttpClient, HttpClientModule, HttpHeaders } from '@angular/common/http';
import {
  Project,
  Location,
  ProjectStatus,
  Company,
  ProjectSchedule,
  ProjectScheduleLineItem,
  ProductModelClass,
  ProductType,
  ProductTypeCategory,
  ProductModel,
  AppUser,
  Employee,
  ProjectMarket,
  CompanyRole,
  UserRole,
  Permission,
  WinProbabilityOption,
  ProjectPhase,
  //CompanyGroup,
  CategoryMultiplierTransactionType,
  Brand,
  ProjectQuote,
  EngineeringRequest,
  ProjectQuoteNetAdds,
  Distributor,
  ProjectQuoteCatMultiplier,
  ProjectQuoteMultiplierRequest,
  ProjectQuoteStatus,
  ProjectQuoteDiscount,
  ReasonLost,
  ProjectAttachment,
  CompanyRegionsByCounty,
  NotifyProjectLocationSalesRegionRequest,
  CompanyCounties,
  County,
  StatesProvinces,
  ProductConfiguration,
  ReleaseNote,
} from '../models/dbmodels';
import {
  CoilConfigurationViewModel,
  ConfigurationTypeViewModel,
  UnitSizeViewModel,
  UnitVoltageViewModel,
  AirMotorTypeViewModel,
  AirFanSpeedViewModel,
  AirSelectByViewModel,
  AirCoilConnectionViewModel,
  CoolSelectionMethodViewModel,
  CoolFilterMethodViewModel,
  CoolFluidTypeViewModel,
  HeatCoilRowsConfigurationViewModel,
  HeatSelectionMethodViewModel,
  HeatFilterMethodViewModel,
  HeatFluidTypeViewModel,
  EHeatCapacityViewModel,
  AppDtoResponse,
  NotificationTypeEnum,
  ResponseTypeEnum,
  FilterPressureDropParameter,
  FilterPressureDropDataResponse,
  FilterPressureDropDataRequest,
  ProjectScheduleGridColumn,
} from '../models/config-view-models';
import { Observable, debounceTime, fromEvent, lastValueFrom, map, takeUntil } from 'rxjs';
import {
  AddressLookupData,
  AppUserRegisterRequest,
  AppUserRegisterResponse,
  AppUserSearchRequest,
  AppUserSearchResponse,
  AppUserUpdateRequest,
  AppUserUpsertRequest,
  AppUserUpsertResponse,
  AppUserUserRoleDeleteRequest,
  AppUserUserRoleUpsertRequest,
  CategoryMultiplierDeleteRequest,
  CategoryMultiplierDeleteResponse,
  CategoryMultiplierSearchRequest,
  CategoryMultiplierSearchResponse,
  CategoryMultiplierUpsertRequest,
  CategoryMultiplierUpsertResponse,
  ChangePasswordRequest,
  CompanyLogoFileProvider,
  CompanyRolePermissionUpdateRequest,
  CompanySearchRequest,
  CompanySearchResponse,
  CompanyUpdateRequest,
  CompanyUpdateResponse,
  CompanyUpsertRequest,
  CompanyUpsertResponse,
  CustomerProject,
  EmployeeCompanyRoleDeleteRequest,
  EmployeeCompanyRoleUpdateResponse,
  EmployeeCompanyRoleUpsertRequest,
  EmployeeDeactivateRequest,
  EmployeeDeactivateResponse,
  EmployeeRoleDeleteRequest,
  EmployeeRoleUpsertRequest,
  EmployeeSearchRequest,
  EmployeeSearchResponse,
  EmployeeUpdateRequest,
  EmployeeUpdateResponse,
  EmployeeUpsertRequest,
  EmployeeUpsertResponse,
  EventLogSearchRequest,
  EventLogSearchResponse,
  ForgotPasswordRequest,
  ForgotPasswordResponse,
  LoginRequest,
  LoginResponse,
  OdataResult,
  ProjectAddUserRequest,
  ProjectAttachmentStatusUpdateRequest,
  ProjectAttachmentStatusUpdateResponse,
  ProjectAttachmentUploadResponse,
  ProjectLocationUpsertRequest,
  ProjectLocationUpsertResponse,
  ProjectRemoveUserRequest,
  ProjectSearchRequest,
  ProjectSearchResponse,
  ProjectStatusUpdateRequest,
  ProjectStatusUpdateResponse,
  RegionSearchRequest,
  RegionSearchResponse,
  RegionUpdateRequest,
  RegionUpdateResponse,
  ResetPasswordRequest,
  ResetPasswordResponse,
  SelectLookup,
  SubmittalReportRequest,
  SubmittalReportResponse,
  UserCompanyUpsertRequest,
  UserCompanyUpsertResponse,
  UserInfoViewModel,
  UserRolePermissionUpdateRequest,
  ProjectQuoteUpsertRequest,
  ProjectQuoteUpsertResponse,
  EngineeringRequestDeleteRequest,
  EngineeringRequestDeleteResponse,
  ProjectQuoteNetAddsDeleteRequest,
  ProjectQuoteNetAddsDeleteResponse,
  DistributorUpsertRequest,
  DistributorUpsertResponse,
  DistributorDeleteResponse,
  DistributorDeleteRequest,
  DistributorSearchRequest,
  DistributorSearchResponse,
  Lookup,
  ProjectQuotePdfRequest,
  ProjectQuoteCatMultiplierUpsertResponse,
  ProjectQuoteCatMultiplierUpsertRequest,
  ToggleStatusResponse,
  ResetPasswordViewModel,
  ProjectScheduleLocationUpsertRequest,
  ProjectScheduleLocationUpsertResponse,
  ProjectQuoteLocationUpsertRequest,
  ProjectQuoteLocationUpsertResponse,
  ProjectQuoteEngRequestDTO,
  ProjectQuoteNoteUpsertRequest,
  ProjectQuoteNoteUpsertResponse,
  ProjectQuoteNote,
  ProjectQuoteDiscountUpsertRequest,
  ProjectQuoteDiscountUpsertResponse,
  NotificationDTO,
  EventLogInvalidUserCreateRequest,
  CloseQuoteRequest,
  CreateMultiplierRequestDto,
  CompanyLocationUpsertRequest,
  CompanyLocationUpsertResponse,
  CompanyLocation,
  CompanyLocationDeleteResponse,
  CompanyLocationDeleteRequest,
  ReviewMultiplierRequestResponse,
  ReviewMultiplierRequest,
  FreightEstimateResponse,
  FreightEstimateRequest,
  ProjectQuoteRequestRequest,
  MoreInfoEmailRequest,
  ProjectQuoteRequestResponse,
  ProductTypeCategoryMultiplierRange,
  CompanyCountyUpsertRequest,
  CompanyCountyUpsertResponse,
  ReleaseNotesUpsertResponse,
  ReleaseNotesUpsertRequest,
  ReleaseNotesDismissRequest,
} from '../models/viewmodels';
import { ProjectByIdResponse, ProjectQuotesByProjectIdResponse, ProjectScheduleSearchRequest, ProjectScheduleSearchResponse } from '../models/request-response-models';
import { environment } from 'src/environments/environment';
import { NotificationService } from './notification.service';
import { v7 as uuidv7 } from 'uuid';
import { UserRoleEnumNumeric } from '../models/lookup-view-models';

@Injectable({
  providedIn: 'root'
})
export class DataService {

  http: HttpClient;
  baseUrl: string = environment.apiUrl;

  constructor(http: HttpClient) { 
    this.http = http;
    this.clientId = uuidv7();
  }

  clientId: string = 'defaultClientId';

  getClientId() {
    return this.clientId ?? uuidv7(); //return random id if clientId is not set
  }

  getAppUsers(includeInactive: boolean = false) {
    let rtn = this.http.get<AppUser[]>(this.baseUrl + "api/appuser?includeInactive=" + includeInactive);
    return rtn;
  }

  getActiveUsers() {
    let rtn = this.http.get<AppUser[]>(this.baseUrl + "api/Heartbeat/");
    return rtn;
  }

  getCodeStringByCodeStringDisplayValue(id: string) {
    let rtn = this.http.get<string>(this.baseUrl + "api/ProjectSchedule/GetByCodeStringDisplayValue/" + id);
    return rtn;
  }

  getAppUser(appUserId: number) : Observable<AppUser> {
    //no parameters, information comes from api reading token
    let rtn = this.http.get<AppUser>(this.baseUrl + "api/appuser/getById?appUserId=" + appUserId,
    {
      'headers': {
        'Content-Type' : 'application/json',
        //'Access-Control-Allow-Origin': 'http://localhost:8100',
      }
    });
    return rtn;
  }

  userExistsByEmail(email: string) : Observable<boolean> {
    //no parameters, information comes from api reading token
    let rtn = this.http.get<boolean>(this.baseUrl + "api/appuser/userExistsByEmail?email=" + email,
    {
      'headers': {
        'Content-Type' : 'application/json',
        //'Access-Control-Allow-Origin': 'http://localhost:8100',
      }
    });
    return rtn;
  }
   projectNameExists(projectName: string) : Observable<boolean> {
    //no parameters, information comes from api reading token
    let requestId = uuidv7();

    let rtn = this.http.get<boolean>(this.baseUrl + "api/project/projectNameExists/" + projectName + "?requestId=" + requestId,
    {
      'headers': {
        'Content-Type' : 'application/json',
        //'Access-Control-Allow-Origin': 'http://localhost:8100',
      }
    });
    return rtn;
  }

  scheduleNameExists(projectId: number, projectScheduleId: number, scheduleName: string): Observable<boolean> {
    const requestId = uuidv7();
    const encodedName = encodeURIComponent(scheduleName);


    const url = `${this.baseUrl}api/ProjectSchedule/scheduleNameExists/${projectId}/${projectScheduleId}/${encodedName}?requestId=${requestId}`;

    return this.http.get<boolean>(url, {
      headers: {
        'Content-Type': 'application/json',
      }
    });
  }

  productTypeExistsWithinSchedule(scheduleId: number, productTypeId) : Observable<boolean> {
    //no parameters, information comes from api reading token
    let rtn = this.http.get<boolean>(this.baseUrl + "api/productType/ProductTypeExistWithinInSchedule?scheduleId=" + scheduleId + "&productTypeId=" + productTypeId,
    {
      'headers': {
        'Content-Type' : 'application/json',
        //'Access-Control-Allow-Origin': 'http://localhost:8100',
      }
    });
    return rtn;
  }

  validatePassword(userId:number,password: string) : Observable<boolean> {
    //no parameters, information comes from api reading token
    let rtn = this.http.get<boolean>(this.baseUrl + "api/appuser/validatePassword?userId="+userId+"&password=" + encodeURIComponent(password),
    {
      'headers': {
        'Content-Type' : 'application/json',
        //'Access-Control-Allow-Origin': 'http://localhost:8100',
      }
    });
    return rtn;
  }
  
  forgotPassword(forgotPasswordRequest: ForgotPasswordRequest) : Observable<ForgotPasswordResponse> {
    //no parameters, information comes from api reading token
    let res = this.http.post<ForgotPasswordResponse>(this.baseUrl + "api/appuser/forgotPassword", forgotPasswordRequest,
    {
      'headers': {
        'Content-Type' : 'application/json'
        //'Access-Control-Allow-Origin': 'http://localhost:8100',
      }
    });
    return res;
  }
  resetPassword(forgotPasswordRequest: ResetPasswordRequest) : Observable<ResetPasswordResponse> {
    //no parameters, information comes from api reading token
    let res = this.http.post<ForgotPasswordResponse>(this.baseUrl + "api/appuser/resetPassword", forgotPasswordRequest,
    {
      'headers': {
        'Content-Type' : 'application/json'
        //'Access-Control-Allow-Origin': 'http://localhost:8100',
      }
    });
    return res;
  }



  //cns: returning a funciton - calling method determines if it wants to wait or not
  async updateAppUserProfile(request: AppUserUpdateRequest) : Promise<UserInfoViewModel> {
    //console.log('updateAppUserProfile', request);
    let response = await lastValueFrom(this.http.put(this.baseUrl + "api/appuser/updateprofile", JSON.stringify(request),
    {
      'headers': {
        'Content-Type' : 'application/json'
      }
    }));
    return response;
  }
  async updateAppUser(request: AppUserUpdateRequest) : Promise<UserInfoViewModel> {
    //console.log('updateAppUser', request);
    let response = await lastValueFrom(this.http.put(this.baseUrl + "api/appuser/update", JSON.stringify(request),
    {
      'headers': {
        'Content-Type' : 'application/json'
      }
    }));
    return response;
  }
  async upsertAppUser(request: AppUserUpsertRequest) : Promise<AppUserUpsertResponse> {
    //console.log('updateAppUser', request);
    let response = await lastValueFrom(this.http.put<AppUserUpsertResponse>(this.baseUrl + "api/appuser/upsert", JSON.stringify(request),
    {
      'headers': {
        'Content-Type' : 'application/json'
      }
    }));
    return response;
  }
  async changePassword(request: ChangePasswordRequest) : Promise<AppUser> {
    //console.log('changePassword', request);
    let response = await lastValueFrom(this.http.put(this.baseUrl + "api/appuser/changepassword", JSON.stringify(request),
    {
      'headers': {
      'Content-Type' : 'application/json; charset=utf-8'
      }
    }));
    return response;
  }

  putImpersonateUserStart(userId: number) : Observable<UserInfoViewModel> {
    //no parameters, information comes from api reading token
    let request = { "UserId": userId};
    let rtn = this.http.put<UserInfoViewModel>(this.baseUrl + "api/appuser/impersonateuserstart", JSON.stringify(request),
    {
      'headers': {
        'Content-Type' : 'application/json'
      }
    });

    return rtn;
  }
  putImpersonateUserStop() : Observable<UserInfoViewModel> {
    //no parameters, information comes from api reading token
    let rtn = this.http.put<UserInfoViewModel>(this.baseUrl + "api/appuser/impersonateuserstop",
    {
      'headers': {
        'Content-Type' : 'application/json'
      }
    });

    return rtn;
  }

  getCurrentUserInfo() : Observable<UserInfoViewModel> {
    //no parameters, information comes from api reading token
    let rtn = this.http.get<UserInfoViewModel>(this.baseUrl + "api/appuser/getCurrentUserInfo/" + this.clientId,
    {
      'headers': {
        'Content-Type' : 'application/json',
      }
    })
    .pipe(
      map(response => {
        if (response == null) {
          return null;
        }

        let userInfoResponse: UserInfoViewModel = response;
        if (userInfoResponse.ClientId == this.clientId) {
          return response;
        } else {
          return null;
        }
      }));

      return rtn;
  }

  IsAuthenticated() : Observable<boolean> {

    let requestId = uuidv7();

    let rtn = this.http.get<boolean>(this.baseUrl + `api/appuser/isauthenticated?requestId=` + requestId,
      {
        'headers': {
          'Content-Type' : 'application/json',
        }
      });
      return rtn;
  }

  LogoutUser() : Observable<boolean> {
    let rtn = this.http.get<boolean>(this.baseUrl + `api/appuser/logoutuser`,
      {
        'headers': {
          'Content-Type' : 'application/json',
        }
      });
      return rtn;
  }

  createInvalidUserEventLog(request: EventLogInvalidUserCreateRequest)  {

    let urlStr = this.baseUrl + 'api/eventlog/InvalidUserEvent';
      this.http.post(urlStr, request).subscribe({
        next: () => {},   // ignore success
        error: () => {}   // optionally ignore errors
      });

      return;
  }

  searchAppUsers(searchRequest: AppUserSearchRequest) : Observable<AppUserSearchResponse>  {
    let urlParameters = Object.entries(searchRequest).map(e => e.join('=')).join('&');
    let url = this.baseUrl + "api/appuser/search?" + urlParameters;

    return this.http.get<AppUserSearchResponse>(url,
    {
      'headers': {
        'Content-Type' : 'application/json'
      }
    });
  }

  loginUser(loginViewModel: LoginRequest): Observable<LoginResponse> {
    let rtn = this.http.post<LoginResponse>(this.baseUrl + "api/AppUser/Login", JSON.stringify(loginViewModel));
    return rtn;
  }

  registerUser(registerUserRequest: AppUserRegisterRequest) : Observable<AppUserRegisterResponse> {
    let response = this.http.post<AppUserRegisterResponse>(this.baseUrl + "api/appuser/register", JSON.stringify(registerUserRequest));
    return response;
  }

  //companies
  getCompanies() {
    let rtn = this.http.get<Company[]>(this.baseUrl + "api/Company");
    return rtn;
  }
  
  getCustomerProjects(companyId: number): Observable<OdataResult<CustomerProject>>  { //TODO: Might need to remove this once the server side is concrete enough for release
    let rtn = this.http.get<OdataResult<CustomerProject>>(this.baseUrl + `api/project/odata/GetCustomerProjects/${companyId}`);
    return rtn;
  }
  // //cns: to be deleted
  // searchCompanies222(searchRequest: CompanySearchRequest) : Observable<CompanySearchResponse>  {
  //   let urlParameters = Object.entries(searchRequest).map(e => e.join('=')).join('&');
  //   let url = this.baseUrl + "api/company/search?" + urlParameters;
  // }

  searchCompanies(searchRequest: CompanySearchRequest) : Observable<CompanySearchResponse>  {
    //console.log('searchCompany', searchRequest);
    let url = this.baseUrl + "api/company/search";

    return this.http.post<CompanySearchResponse>(url, JSON.stringify(searchRequest),
    {
      'headers': {
        'Content-Type' : 'application/json'
      }
    });
  }

  async searchCompaniesAsync(request: CompanySearchRequest) : Promise<CompanySearchResponse>  {
    //console.log('searchCompany', searchRequest);
    let url = this.baseUrl + "api/company/search";

    let response = await lastValueFrom(this.http.post<CompanySearchResponse>(url, JSON.stringify(request),
    {
      'headers': {
        'Content-Type' : 'application/json'
      }
    }));
    return response;
  }

  async updateCompany(request: CompanyUpdateRequest) : Promise<CompanyUpdateResponse> {
    //console.log('updateAppUser', request);
    console.log('upsertCompany', request);
    let url = this.baseUrl + "api/company/update";
    let response = await lastValueFrom(this.http.put<CompanyUpdateResponse>(url, JSON.stringify(request),
    {
      'headers': {
        'Content-Type' : 'application/json'
      }
    }));
    return response;
  }

  async upsertCompany(request: CompanyUpsertRequest) : Promise<CompanyUpsertResponse> {
    //console.log('updateAppUser', request);
    console.log('upsertCompany', request);
    let url = this.baseUrl + "api/company/upsert";
    let response = await lastValueFrom(this.http.put<CompanyUpsertResponse>(url, JSON.stringify(request),
    {
      'headers': {
        'Content-Type' : 'application/json'
      }
    }));
    return response;
  }

  async upsertCompanyLogo(file:File, companyId:number): Promise<string> {
    //console.log('upsertCompanyLogo', companyId, file.name, file.size);
    const formData: FormData = new FormData();
    formData.append('companyId', companyId.toString());
    formData.append('file', file, file.name);

    //console.log('upsertCompanyLogo',formData)
    const httpOptions = {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    };

    let url = this.baseUrl + "api/company/UpsertCompanyLogo";
    let response = await lastValueFrom(this.http.post<string>(url, formData, httpOptions));
    console.log('upsertCompanyLogo - api - response', response);
    return response;
  }

  async updateCompanyStatus(request: CompanyUpdateRequest) : Promise<CompanyUpdateResponse> {
    //console.log('updateAppUser', request);
    let url = this.baseUrl + "api/company/UpdateStatus";
    let response = await lastValueFrom(this.http.put<CompanyUpdateResponse>(url, JSON.stringify(request),
    {
      'headers': {
        'Content-Type' : 'application/json'
      }
    }));
    return response;

  }
  async upsertParentCompany(companyId: number, parentCompanyIds: number[]) : Promise<CompanyUpsertResponse> {
    let url = this.baseUrl + "api/company/UpsertParentCompany";
    let request = {
      CompanyId: companyId,
      ParentCompanyIds: parentCompanyIds
    };
    let response = await lastValueFrom(this.http.put<CompanyUpsertResponse>(url, JSON.stringify(request),
    { 
      'headers': {
        'Content-Type' : 'application/json'
      }
    }));
    return response;
  }
  getParentCompanies(companyId: number) : Observable<Company[]> {
    let rtn = this.http.get<Company[]>(this.baseUrl + "api/company/GetParentCompanies/" + companyId);
    return rtn;
  }
  getChildCompanies(companyId: number) : Observable<Company[]> {
    let rtn = this.http.get<Company[]>(this.baseUrl + "api/company/GetParentChildCompanies/" + companyId);
    return rtn;
  }
  getCompanyDistributors(companyId: number) : Observable<Distributor[]> {
    let rtn = this.http.get<Distributor[]>(this.baseUrl + "api/company/GetDistributorsByCompanyId/" + companyId);
    return rtn;
  }
  // getCompanyGroups(includeInactive: boolean = false) : Observable<CompanyGroup[]> {
  //   let rtn = this.http.get<CompanyGroup[]>(this.baseUrl + "api/Company/getcompanygroups?includeInactive=" + includeInactive);
  //   return rtn;
  // }
  getBrands() : Observable<Brand[]> {
    let requestId = uuidv7();
    let rtn = this.http.get<Brand[]>(this.baseUrl + "api/Brand/getBrands?requestId=" + requestId);
    return rtn;
  }
  async getProjectLogoImage(projectId: number) : Promise<any> {
    let response = await lastValueFrom(this.http.get(this.baseUrl + "api/project/projectlogoimage/" + projectId, { responseType: 'blob' }));
    return response;
  }
  async getCompanyLogoImage(companyId: number) : Promise<any> {
    let response = await lastValueFrom(this.http.get(this.baseUrl + "api/company/logos/" + companyId, { responseType: 'blob' }));
    return response;
  }
  async getBrandLogoImage(brandId: number) : Promise<any> {
    let response = await lastValueFrom(this.http.get(this.baseUrl + "api/brand/logos/" + brandId, { responseType: 'blob' }));
    return response;
  }

  searchEmployees(searchRequest: EmployeeSearchRequest) : Observable<EmployeeSearchResponse>  {
    //console.log('searchEmployees', searchRequest);
    let url = this.baseUrl + "api/employee/search";

    return this.http.post<EmployeeSearchResponse>(url, JSON.stringify(searchRequest),
    {
      'headers': {
        'Content-Type' : 'application/json'
      }
    });
  }

  searchEmployeesAsync(searchRequest: EmployeeSearchRequest) : Promise<EmployeeSearchResponse>  {
    console.log('searchEmployees', searchRequest);
    //let urlParameters = Object.entries(searchRequest).map(e => e.join('=')).join('&');
    let url = this.baseUrl + "api/employee/search";

    let response = lastValueFrom(this.http.post<EmployeeSearchResponse>(url, JSON.stringify(searchRequest),
    {
      'headers': {
        'Content-Type' : 'application/json'
      }
    }));
    return response;
  }


/*   async updateEmployee(request: EmployeeUpdateRequest) : Promise<EmployeeUpdateResponse> {
    //console.log('updateAppUser', request);
    let response = await lastValueFrom(this.http.put<EmployeeUpdateResponse>(this.baseUrl + "api/employee/UpdateEmployee", JSON.stringify(request),
    {
      'headers': {
        'Content-Type' : 'application/json'
      }
    }));
    return response;
  } */
  async upsertEmployee(request: EmployeeUpsertRequest) : Promise<EmployeeUpsertResponse> {
    //console.log('updateAppUser', request);
    let response = await lastValueFrom(this.http.put<EmployeeUpsertResponse>(this.baseUrl + "api/employee/UpsertEmployee", JSON.stringify(request),
    {
      'headers': {
        'Content-Type' : 'application/json'
      }
    }));
    return response;
  }
  //cns: focuses on adding user to a company, manager, and roles
  async upsertUserCompany(request: UserCompanyUpsertRequest) : Promise<UserCompanyUpsertResponse> {
    let response = await lastValueFrom(this.http.put<UserCompanyUpsertResponse>(this.baseUrl + "api/employee/UpsertUserCompany", JSON.stringify(request),
    {
      'headers': {
        'Content-Type' : 'application/json'
      }
    }));
    return response;
  }

  //employee roles
  getCompanyRoles() : Observable<CompanyRole[]>{
    let rtn = this.http.get<CompanyRole[]>(this.baseUrl + "api/companyrole");
    return rtn;
  }
  async getCompanyRolesAsync() : Promise<CompanyRole[]>{
    //let rtn = this.http.get<CompanyRole[]>(this.baseUrl + "api/companyrole");
    //return rtn;
    let response = await lastValueFrom(this.http.get<CompanyRole[]>(this.baseUrl + "api/companyrole"));
    return response;
  }
  async upsertEmployeeCompanyRole(request: EmployeeCompanyRoleUpsertRequest) : Promise<EmployeeCompanyRoleUpdateResponse> {
    console.log('upsertEmployeeCompanyRole', request);
    let response = await lastValueFrom(this.http.put<EmployeeUpdateResponse>(this.baseUrl + "api/employee/UpsertEmployeeCompanyRole", JSON.stringify(request),
    {
      'headers': {
        'Content-Type' : 'application/json'
      }
    }));
    return response;
  }
  async deactivateEmployee(request: EmployeeDeactivateRequest) : Promise<EmployeeDeactivateResponse> {
    //console.log('deleteEmployeeCompanyRole', request);
    let response = await lastValueFrom(this.http.put<EmployeeDeactivateResponse>(this.baseUrl + "api/employee/EmployeeDeactivate", JSON.stringify(request),
    {
      'headers': {
        'Content-Type' : 'application/json'
      }
    }));
    return response;
  }
  deleteEmployeeCompanyRole(request: EmployeeCompanyRoleDeleteRequest) {
    console.log('deleteEmployeeCompanyRole', request);

    let response = this.http.put(this.baseUrl + "api/employee/DeleteEmployeeCompanyRole", JSON.stringify(request),
    {
      'headers': {
        'Content-Type' : 'application/json'
      }
    });
    return response;
  }
  updateCompanyRolePermissions(request: CompanyRolePermissionUpdateRequest) {
    console.log('updateCompanyRolePermissions', request);
    let response = this.http.put(this.baseUrl + "api/companyrole/updatecompanyrolepermission", JSON.stringify(request),
    {
      'headers': {
        'Content-Type' : 'application/json'
      }
    });
    return response;
  }

  getAddressLookUpData() : Observable<AddressLookupData> {
    //no parameters, information comes from api reading token
    let rtn = this.http.get<AddressLookupData>(this.baseUrl + "api/location/AddressLookUpData",
    {
      'headers': {
        'Content-Type' : 'application/json',
      }
    });
    return rtn;
  }

  getLocationById(locationId: number) : Observable<Location> {
    let rtn = this.http.get<Location>(this.baseUrl + "api/location/" + locationId,
    {
      'headers': {
        'Content-Type' : 'application/json',
      }
    });
    return rtn;
  }

  //employees
  getEmployeesByUserId(userId: number) : Observable<Employee[]> {
    let rtn = this.http.get<Employee[]>(this.baseUrl + "api/employee/getbyuserid/" + userId);
    return rtn;
  }
  getEmployeeById(employeeId: number) : Observable<Employee> {
    let rtn = this.http.get<Employee>(this.baseUrl + "api/employee/getbyid/" + employeeId);
    return rtn;
  }
  getEmployeesByUserIdAsync(userId: number) : Promise<Employee[]> {
    let response = lastValueFrom(this.http.get<Employee[]>(this.baseUrl + "api/employee/getbyuserid/" + userId));
    return response;
    //let rtn = this.http.get<Employee[]>(this.baseUrl + "api/employee/getbyuserid/" + userId);
    //return rtn;
  }
  getPermissions() {
    let rtn = this.http.get<Permission[]>(this.baseUrl + "api/permission");
    return rtn;
  }
  //user roles - are user-specific, not company-specific
  getUserRoles() {
    let rtn = this.http.get<UserRole[]>(this.baseUrl + "api/userrole");
    return rtn;
  }
  getUserRolesAsync() : Promise<UserRole[]> {
    // let rtn = this.http.get<UserRole[]>(this.baseUrl + "api/userrole");
    // return rtn;
    let response = lastValueFrom(this.http.get<UserRole[]>(this.baseUrl + "api/userrole"));
    return response;
  }
  upsertAppUserUserRole(request: AppUserUserRoleUpsertRequest) {
    console.log('upsertAppUserUserRole', request);
    let response = this.http.put(this.baseUrl + "api/appuser/UpsertAppUserUserRole", JSON.stringify(request),
    {
      'headers': {
        'Content-Type' : 'application/json'
      }
    });
    return response;
  }
  updateUserRolePermissions(request: UserRolePermissionUpdateRequest) {
    console.log('upsertAppUserUserRole', request);
    let response = this.http.put(this.baseUrl + "api/userrole/updateuserrolepermission", JSON.stringify(request),
    {
      'headers': {
        'Content-Type' : 'application/json'
      }
    });
    return response;
  }
  deleteAppUserUserRole(request: AppUserUserRoleDeleteRequest) {
    console.log('deleteAppUserUserRole', request);

    let response = this.http.put(this.baseUrl + "api/appuser/DeleteAppUserUserRole", JSON.stringify(request),
    {
      'headers': {
        'Content-Type' : 'application/json'
      }
    });
    return response;
  }

  getUsersByUserRole(userRoleId: number) : Observable<AppUser[]> {
    let rtn = this.http.get<AppUser[]>(this.baseUrl + "api/appuser/GetUserByUserRole/" + userRoleId,
    {
      'headers': {
        'Content-Type' : 'application/json',
      }
    });
    return rtn;
  }
  getUsersByUserRoleEnum(userRoleEnum: UserRoleEnumNumeric) : Observable<AppUser[]> {
    let rtn = this.http.get<AppUser[]>(this.baseUrl + "api/appuser/GetUserByUserRoleEnum/" + userRoleEnum,
    {
      'headers': {
        'Content-Type' : 'application/json',
      }
    });
    return rtn;
  }

  getProjects() {
    //console.log('getProjects', this.baseUrl + "api/Project");
    let rtn = this.http.get<Project[]>(this.baseUrl + "api/Project");
    return rtn;
  }

  getProject<Project>(projectId: number) : Observable<Project> {
    let requestUrl = this.baseUrl + "api/Project/" + projectId;

    let rtn = this.getData<Project>(requestUrl);
    return rtn;
  }
  getProjectById<Project>(projectId: number) : Observable<ProjectByIdResponse> {
    let requestUrl = this.baseUrl + "api/Project/GetById/" + projectId;

    let rtn = this.getData<Project>(requestUrl);
    return rtn;
  }
  getProjectAndScheduleShipToBillTo<Project>(projectId: number) : Observable<Project> {
    let requestUrl = this.baseUrl + "api/Project/GetProjectAndScheduleShipToBillTo/" + projectId;
    let rtn = this.getData<Project>(requestUrl);
    return rtn;
  }
  getProjectShallow<Project>(projectId: number) : Observable<Project> {
    let requestUrl = this.baseUrl + "api/Project/GetShallow/" + projectId;

    let rtn = this.getData<Project>(requestUrl);
    return rtn;
  }
  getProjectByIdShallow<Project>(projectId: number) : Observable<ProjectByIdResponse> {
    let requestUrl = this.baseUrl + "api/Project/GetByIdShallow/" + projectId;

    let rtn = this.getData<Project>(requestUrl);
    return rtn;
  }

  searchProject(searchRequest: ProjectSearchRequest) : Observable<ProjectSearchResponse>  {
    //console.log('searchProject', searchRequest);
    //let urlParameters = Object.entries(searchRequest).map(e => e.join('=')).join('&');
    let url = this.baseUrl + "api/project/search";

    return this.http.post<ProjectSearchResponse>(url, JSON.stringify(searchRequest),
    {
      'headers': {
        'Content-Type' : 'application/json'
      }
    });
  }

  searchEventLog(searchRequest: EventLogSearchRequest) : Observable<EventLogSearchResponse>  {
    let urlParameters = Object.entries(searchRequest).map(e => e.join('=')).join('&');
    let url = this.baseUrl + "api/eventlog/search?" + urlParameters;

    return this.http.get<EventLogSearchResponse>(url,
    {
      'headers': {
        'Content-Type' : 'application/json'
      }
    });
  }

  async createProject(project: Project) : Promise<Project> {
    console.log('createProject', project);
    let response = await lastValueFrom(this.http.post(this.baseUrl + "api/project", JSON.stringify(project),
    {
      'headers': {
        'Content-Type' : 'application/json'
      }
    }));
    return response;
  }

  //cns: returning a funciton - calling method determines if it wants to wait or not
  async updateProject(project: Project) : Promise<Project> {
    console.log('updateProject', project);
    let response = await lastValueFrom(this.http.put(this.baseUrl + "api/project/update", JSON.stringify(project),
    {
      'headers': {
        'Content-Type' : 'application/json'
      }
    }));
    return response;
  }
  async updateProjectStatus(project: ProjectStatusUpdateRequest) : Promise<ProjectStatusUpdateResponse> {
    //console.log('updateProjectStatus', project);
    let response = await lastValueFrom(this.http.put<ProjectStatusUpdateResponse>(this.baseUrl + "api/project/updateStatus", JSON.stringify(project),
    {
      'headers': {
        'Content-Type' : 'application/json'
      }
    }));
    return response;
  }
  async getProjectAttachment(attachmentId: number) : Promise<any> {
    let response = await lastValueFrom(this.http.get(this.baseUrl + "api/project/attachments/" + attachmentId, { responseType: 'blob' }));
    return response;
  }
  async upsertProjectAttachment(file:File, attachmentName: string, projectId:number,  attachmentLookupValue: number,projectQuoteId?: number): Promise<ProjectAttachmentUploadResponse> {
    //console.log('upsertProjectAttachment', projectId, file.name, file.size);
    const formData: FormData = new FormData();
    formData.append('projectId', projectId.toString());
    formData.append('projectQuoteId', projectQuoteId?.toString() ?? '');
    formData.append('attachmentName', attachmentName);
    formData.append('file', file, file.name);
    formData.append('projectAttachmentLookupValue', attachmentLookupValue.toString());

    //console.log('upsertCompanyLogo',formData)
    const httpOptions = {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    };

    let url = this.baseUrl + "api/project/UpsertProjectAttachment";
    let response = await lastValueFrom(this.http.post<ProjectAttachmentUploadResponse>(url, formData, httpOptions));
    //console.log('UpsertProjectAttachment - api - response', response);
    return response;
  }
  async updateProjectAttachmentStatus(project: ProjectAttachmentStatusUpdateRequest) : Promise<ProjectAttachmentStatusUpdateResponse> {
    //console.log('updateProjectStatus', project);
    let response = await lastValueFrom(this.http.put<ProjectAttachmentStatusUpdateResponse>(this.baseUrl + "api/project/UpdateAttachmentStatus", JSON.stringify(project),
    {
      'headers': {
        'Content-Type' : 'application/json'
      }
    }));
    return response;
  }
  async getProjectAttachmentsByProjectId(projectId: number) : Promise<ProjectAttachment[]> {
    let response = await lastValueFrom(this.http.get<ProjectAttachment[]>(this.baseUrl + "api/project/GetAttachmentsByProjectId/" + projectId));
    return response;
  }
  async projectUserAdd(request: ProjectAddUserRequest) : Promise<Project> {
    //console.log('projectUserAdd', request);
    let response = await lastValueFrom(this.http.put(this.baseUrl + "api/project/addprojectuser", JSON.stringify(request),
    {
      'headers': {
        'Content-Type' : 'application/json'
      }
    }));
    return response;
  }
  async projectUserRemove(request: ProjectRemoveUserRequest) : Promise<Project> {
    //console.log('projectUserRemove', request);
    let response = await lastValueFrom(this.http.put(this.baseUrl + "api/project/removeprojectuser", JSON.stringify(request),
    {
      'headers': {
        'Content-Type' : 'application/json'
      }
    }));
    return response;
  }
  async upsertProjectLocation(request: ProjectLocationUpsertRequest) : Promise<ProjectLocationUpsertResponse> {
    //console.log('upsertProjectLocation', request);
    let response = await lastValueFrom(this.http.post<ProjectLocationUpsertResponse>(this.baseUrl + "api/project/projectlocationupsert", JSON.stringify(request),
    {
      'headers': {
        'Content-Type' : 'application/json'
      }
    }));
    return response;
  }
  async upsertProjectScheduleLocation(request: ProjectScheduleLocationUpsertRequest) : Promise<ProjectScheduleLocationUpsertResponse> {
    //console.log('upsertProjectLocation', request);
    let response = await lastValueFrom(this.http.post<ProjectScheduleLocationUpsertResponse>(this.baseUrl + "api/projectschedule/projectschedulelocationupsert", JSON.stringify(request),
    {
      'headers': {
        'Content-Type' : 'application/json'
      }
    }));
    return response;
  }

  async upsertCompanyLocation(request: CompanyLocationUpsertRequest) : Promise<CompanyLocationUpsertResponse> {
    //console.log('upsertCompanyLocation', request);
    let response = await lastValueFrom(this.http.post<CompanyLocationUpsertResponse>(this.baseUrl + "api/company/companylocationupsert", JSON.stringify(request),
    {
      'headers': {
        'Content-Type' : 'application/json'
      }
    }));
    return response;
  }

  async addCompanyLocation(request: CompanyLocationUpsertRequest) : Promise<CompanyLocationUpsertResponse> {
    //console.log('addCompanyLocation', request);
    let response = await lastValueFrom(this.http.post<CompanyLocationUpsertResponse>(this.baseUrl + "api/company/addcompanylocation", JSON.stringify(request),
    {
      'headers': {
        'Content-Type' : 'application/json'
      }
    }));
    return response;
  }

  getCompanyLocationsByCompanyId(companyId: number) : Observable<CompanyLocation[]> {
    let rtn = this.http.get<CompanyLocation[]>(this.baseUrl + "api/Company/LocationsByCompanyId/" + companyId);

    return rtn;
  }

  async deleteCompanyLocation(request: CompanyLocationDeleteRequest) : Promise<CompanyLocationDeleteResponse> {
    console.log('deleteCompanyLocation', request);
    let response = await lastValueFrom(this.http.delete<CompanyLocationDeleteResponse>(this.baseUrl + "api/company/DeleteCompanyLocation/", 
      {
        body: JSON.stringify(request),
        headers: {
          'Content-Type' : 'application/json'
        }
      }));
    return response;
  }

  searchCompanyLocations(searchRequest: CompanyLocationUpsertRequest) : Observable<CompanyLocationUpsertResponse>  {
    //console.log('searchCompany', searchRequest);
    let url = this.baseUrl + "api/company/SearchCompanyLocations";

    return this.http.post<CompanyLocationUpsertResponse>(url, JSON.stringify(searchRequest),
    {
      'headers': {
        'Content-Type' : 'application/json'
      }
    });
  }

  getProjectMarkets(includeInactive: boolean = false) {
    //console.log('getProjectMarkets', this.baseUrl + "api/ProjectMarket");
    let rtn = this.http.get<ProjectMarket[]>(this.baseUrl + "api/ProjectMarket?includeInactive=" + includeInactive);
    return rtn;
  }
  getProjectStatuses(includeInactive: boolean = false) {
    //console.log('getProjectMarkets', this.baseUrl + "api/ProjectMarket");
    let rtn = this.http.get<ProjectStatus[]>(this.baseUrl + "api/ProjectStatus?includeInactive=" + includeInactive);
    return rtn;
  }
  getProjectPhases(includeInactive: boolean = false) {
    //console.log('getProjectMarkets', this.baseUrl + "api/ProjectMarket");
    let rtn = this.http.get<ProjectPhase[]>(this.baseUrl + "api/ProjectPhase?includeInactive=" + includeInactive);
    return rtn;
  }
  getProjectWinProbabilityOptions(includeInactive: boolean = false) {
    //console.log('getProjectMarkets', this.baseUrl + "api/ProjectMarket");
    let rtn = this.http.get<WinProbabilityOption[]>(this.baseUrl + "api/project/WinProbabilityOptions?includeInactive=" + includeInactive);
    return rtn;
  }

  getProjectUsers(projectId: number) : Observable<AppUser[]> {
    let rtn = this.http.get<AppUser[]>(this.baseUrl + "api/project/GetProjectUsers/" + projectId);
    return rtn;
  }

  getData<T>(requestUrl: string) {
    let requestObservable = this.http.get<T>(requestUrl);
    return requestObservable;
  }

  getProjectSchedulesByProjectId(projectId: number) : Observable<ProjectSchedule[]> {
    let requestUrl = this.baseUrl + "api/ProjectSchedule/GetByProjectId/" + projectId;
    let rtn = this.getData<ProjectSchedule[]>(requestUrl);
    return rtn;
  }

  getProjectSchedulesByUserId(userId: number) : Observable<ProjectSchedule[]> {
    let requestUrl = this.baseUrl + "api/ProjectSchedule/GetByUserId/" + userId;
    let rtn = this.getData<ProjectSchedule[]>(requestUrl);
    return rtn;
  }

  copyProjectScheduleLineItems(projectScheduleId: number, projectScheduleLineItemIds: number[]) : Observable<any> {
    console.log("in dataservice call")
    let requestUrl = this.baseUrl + "api/ProjectSchedule/CopyLineItems/" + projectScheduleId;
    console.log("requestURL =>", requestUrl);

    let rtn = this.http.post(requestUrl, projectScheduleLineItemIds);
    console.log(rtn);
    return rtn;
  }

  async createProjectSchedule(projectSchedule: ProjectSchedule) {
    console.log('addProjectSchedule', projectSchedule);
    let response = await lastValueFrom(this.http.post(this.baseUrl + "api/projectschedule", JSON.stringify(projectSchedule),
    {
      'headers': {
        'Content-Type' : 'application/json'
      }
    }));
    return response;
  }

  async updateProjectSchedule(projectSchedule: ProjectSchedule) {
    console.log('updateProjectSchedule', projectSchedule);
    let response = await lastValueFrom(this.http.put(this.baseUrl + "api/projectschedule", JSON.stringify(projectSchedule),
    {
      'headers': {
        'Content-Type' : 'application/json'
      }
    }));
    return response;
  }

  getProductTypeCategories() : Observable<ProductTypeCategory[]> {
    let rtn: ProductTypeCategory[] = [];
    var results = this.http.get<ProductTypeCategory[]>(this.baseUrl + "api/ProductTypeCategory");
    return results;
  }

  getCategoryMultiplierTransactionTypes() : Observable<CategoryMultiplierTransactionType[]> {
    let rtn: CategoryMultiplierTransactionType[] = [];
    var results = this.http.get<CategoryMultiplierTransactionType[]>(this.baseUrl + "api/ProductTypeCategoryMultiplier/CategoryMultiplierTransactionTypes");
    return results;
  }

  getProductModelClasses(): ProductModelClass[] {
    var rtn: ProductModelClass[] = [];
    // var results = this.http.get<ProductModelClass[]>(this.baseUrl + "api/ProductModelClass");
    // return results;
    var productModelClassObservable = this.http.get<ProductModelClass[]>(this.baseUrl + "api/ProductModelClass");
    productModelClassObservable.subscribe((data: any) => {
      rtn = data;
    });
    return rtn;
  }

  getProductModels() : ProductModel[] {
    // var results = this.http.get<ProductModel[]>(this.baseUrl + "api/ProductModel");
    // return results;
    var rtn: ProductModel[] = [];
    var productModelObservable = this.http.get<ProductModel[]>(this.baseUrl + "api/ProductModel");
    productModelObservable.subscribe((data: any) => {
      rtn = data;
    });
    return rtn;
  }

  getProductModelsByModelClassId(productModelClassId: number): ProductModel[] {
    return this.getProductModels().filter(c => c.ProductModelClassId == productModelClassId);
  };

  getProductTypeCategoryMultiplierRange() : Observable<ProductTypeCategoryMultiplierRange[]> {
    var results = this.http.get<ProductTypeCategoryMultiplierRange[]>(this.baseUrl + "api/ProductTypeCategoryMultiplierRange");
    return results;
  }

  updateProductTypeCategoryMultiplierRange(updatedMultiplierRange : ProductTypeCategoryMultiplierRange[]) : Observable<ProductTypeCategoryMultiplierRange[]> {
    var results = this.http.put<ProductTypeCategoryMultiplierRange[]>(this.baseUrl + "api/ProductTypeCategoryMultiplierRange", JSON.stringify(updatedMultiplierRange));
    return results;
  }

  upsertResidentialScheduleLineItem(request: CertPerfDataUpsertRequest): Observable<CertPerfDataUpsertResponse> {
    return this.http.post<CertPerfDataUpsertResponse>(this.baseUrl + 'api/EngineeringProduct/UpsertCertPerfData', request);
  }

  getProjectScheduleLineItem(lineItemId: number) : Observable<ProjectScheduleLineItem> {
    //return null;
    let rtn = this.http.get<ProjectScheduleLineItem>(this.baseUrl + "api/ProjectScheduleLineItem/" + lineItemId);
    return rtn;

  }

  getProjectScheduleLineItemsByScheduleId(projectScheduleId: number) {
    let rtn = this.http.get<ProjectScheduleLineItem[]>(this.baseUrl + "api/ProjectScheduleLineItem/GetByProjectScheduleId/" + projectScheduleId);
    return rtn;
  }
  getGridColumnsProjectScheduleLineItemsByScheduleIdOld(projectScheduleId: number) {
    let rtn = this.http.get<ProjectScheduleLineItem[]>(this.baseUrl + "api/ProjectScheduleLineItem/GetGridColumnsByProjectScheduleIdOld/" + projectScheduleId);
    return rtn;
  }
  getGridColumnsProjectScheduleLineItemsByScheduleId(projectScheduleId: number) {
    let rtn = this.http.get<ProjectScheduleGridColumn[]>(this.baseUrl + "api/ProjectScheduleLineItem/GetGridColumnsByProjectScheduleId/" + projectScheduleId);
    return rtn;
  }
  getProjectSchedule(projectScheduleId: number) {
    let rtn = this.http.get<ProjectSchedule>(this.baseUrl + "api/ProjectSchedule/" + projectScheduleId);
    return rtn;
  }

  searchProjectSchedule(searchRequest: ProjectScheduleSearchRequest) : Observable<ProjectScheduleSearchResponse>  {
    let urlParameters = Object.entries(searchRequest).map(e => e.join('=')).join('&');
    let url = this.baseUrl + "api/projectschedule/search?" + urlParameters;
    
    return this.http.get<ProjectScheduleSearchResponse>(url,
    {
      'headers': {
        'Content-Type' : 'application/json'
      }
    });
  }

  searchRegions(searchRequest: RegionSearchRequest) : Observable<RegionSearchResponse>  {
    console.log('searchRegion', searchRequest);
    //let urlParameters = Object.entries(searchRequest).map(e => e.join('=')).join('&');
    let url = this.baseUrl + "api/region/search";

    return this.http.post<RegionSearchResponse>(url, JSON.stringify(searchRequest),
    {
      'headers': {
        'Content-Type' : 'application/json'
      }
    });
  }
  async updateRegion(request: RegionUpdateRequest) : Promise<RegionUpdateResponse> {
    let response = await lastValueFrom(this.http.put<RegionUpdateResponse>(this.baseUrl + "api/region/update", JSON.stringify(request),
    {
      'headers': {
        'Content-Type' : 'application/json'
      }
    }));
    return response;
  }
  searchCategoryMultipliers(searchRequest: CategoryMultiplierSearchRequest) : Observable<CategoryMultiplierSearchResponse>  {
    console.log('search category multipliers', searchRequest);
    //let urlParameters = Object.entries(searchRequest).map(e => e.join('=')).join('&');
    let url = this.baseUrl + "api/ProductTypeCategoryMultiplier/search";

    return this.http.post<CategoryMultiplierSearchResponse>(url, JSON.stringify(searchRequest),
    {
      'headers': {
        'Content-Type' : 'application/json'
      }
    });
  }
  async upsertCategoryMultiplier(request: CategoryMultiplierUpsertRequest) : Promise<CategoryMultiplierUpsertResponse> {
    let response = await lastValueFrom(this.http.put<CategoryMultiplierUpsertResponse>(this.baseUrl + "api/ProductTypeCategoryMultiplier/upsert", JSON.stringify(request),
    {
      'headers': {
        'Content-Type' : 'application/json'
      }
    }));
    return response;
  }
  async deleteCategoryMultiplier(request: CategoryMultiplierDeleteRequest) : Promise<CategoryMultiplierDeleteResponse> {
    let response = await lastValueFrom(this.http.put<CategoryMultiplierDeleteResponse>(this.baseUrl + "api/ProductTypeCategoryMultiplier/delete", JSON.stringify(request),
    {
      'headers': {
        'Content-Type' : 'application/json'
      }
    }));
    return response;
  }

  getDistributors() {
    let rtn = this.http.get<Distributor[]>(this.baseUrl + "api/Distributor");
    return rtn;
  }

  getDistributorById(distributorId: number) {
    let rtn = this.http.get<Distributor>(this.baseUrl + "api/Distributor/" + distributorId);
    return rtn;
  }

  getDistributorByIdAsync(distributorId: number) : Promise<Distributor> {
    let response = lastValueFrom(this.http.get<Distributor>(this.baseUrl + "api/Distributor/" + distributorId));
    return response;
  }

  async upsertDistributor(request: DistributorUpsertRequest) : Promise<DistributorUpsertResponse> {
    let response = await lastValueFrom(this.http.put<DistributorUpsertResponse>(this.baseUrl + "api/Distributor/upsert", JSON.stringify(request),
    {
      'headers': {
        'Content-Type' : 'application/json'
      }
    }));
    return response;
  }

  async deleteDistributor(request: DistributorDeleteRequest) : Promise<DistributorDeleteResponse> {
    let response = await lastValueFrom(this.http.put<DistributorDeleteResponse>(this.baseUrl + "api/Distributor/delete", JSON.stringify(request),
    {
      'headers': {
        'Content-Type' : 'application/json'
      }
    }));
    return response;
  }

  searchDistributors(searchRequest: DistributorSearchRequest) : Observable<DistributorSearchResponse>  {
    // console.log('search category multipliers', searchRequest);
    let url = this.baseUrl + "api/Distributor/search";
    return this.http.post<DistributorSearchResponse>(url, JSON.stringify(searchRequest),
    {
      'headers': {
        'Content-Type' : 'application/json'
      }
    });
  }

  async upsertProjectQuote(projectQuote: ProjectQuoteUpsertRequest) : Promise<ProjectQuoteUpsertResponse> {
    console.log('addProjectQuote', projectQuote);
    let response = await lastValueFrom(this.http.post<ProjectQuoteUpsertResponse>(this.baseUrl + "api/projectquote", JSON.stringify(projectQuote),
    {
      'headers': {
        'Content-Type' : 'application/json'
      }
    }));
    return response;
  }

  async upsertProjectQuoteLocation(request: ProjectQuoteLocationUpsertRequest) : Promise<ProjectQuoteLocationUpsertResponse> {
    console.log('upsertProjectQuoteLocation', request);
    let response = await lastValueFrom(this.http.post<ProjectQuoteLocationUpsertResponse>(this.baseUrl + "api/projectquote/ProjectQuoteLocationUpsert", JSON.stringify(request),
    {
      'headers': {
        'Content-Type' : 'application/json'
      }
    }));
    return response;
  }

  getProjectQuote(projectQuoteId: number) : Observable<ProjectQuote> {
    let rtn = this.http.get<ProjectQuote>(this.baseUrl + "api/projectquote/" + projectQuoteId);
    return rtn;
  }

  getProjectQuoteByScheduleId(projectScheduleId: number) : Observable<ProjectQuote> {
    let rtn = this.http.get<ProjectQuote>(this.baseUrl + "api/projectquote/" + projectScheduleId);
    return rtn;
  }

  async getProjectQuotes (projectId: number) : Promise<ProjectQuote[]> {
    let response = await lastValueFrom(this.http.get<ProjectQuote[]>(this.baseUrl + "api/projectquote/getbyprojectid/" + projectId));
    return response;
  }
  async getProjectQuotesByProjectId (projectId: number) : Promise<ProjectQuotesByProjectIdResponse> {
    let response = await lastValueFrom(this.http.get<ProjectQuotesByProjectIdResponse>(this.baseUrl + "api/projectquote/getbyprojectidauthorized/" + projectId));
    return response;
  }

  getProjectQuoteStatus() : Observable<ProjectQuoteStatus[]> {
    let rtn = this.http.get<ProjectQuoteStatus[]>(this.baseUrl + "api/ProjectQuote/ProjectQuoteStatuses/");
    return rtn;
  }
  GetProjectQuoteLostReasons() : Observable<ReasonLost[]> {
    let rtn = this.http.get<ReasonLost[]>(this.baseUrl + "api/ProjectQuote/GetLostReasons/");
    return rtn;
}

  async upsertProjectQuoteEngineeringRequest(engRequest: ProjectQuoteEngRequestDTO) : Promise<EngineeringRequest> {
    // console.log('upsertEngineeringRequest', engRequest);
    let response = await lastValueFrom(this.http.post(this.baseUrl + "api/ProjectQuoteEngRequest", JSON.stringify(engRequest),
    {
      'headers': {
        'Content-Type' : 'application/json'
      }
    }));
    return response;
  }

  getProjectQuoteEngRequest(projectQuoteId: number) : Observable<EngineeringRequest> {
    let rtn = this.http.get<EngineeringRequest>(this.baseUrl + "api/ProjectQuoteEngRequest/GetByProjectQuoteId/" + projectQuoteId);
    return rtn;
  }

  async deleteProjectQuoteEngineeringRequest(engRequestId: number) : Promise<EngineeringRequestDeleteResponse> {
    let response = await lastValueFrom(this.http.delete<EngineeringRequestDeleteResponse>(this.baseUrl + `api/ProjectQuoteEngRequest/${engRequestId}`,
    {
      'headers': {
        'Content-Type' : 'application/json'
      }
    }));

    return response;
  }

  getQuoteEngRequestStatusLookups() : Observable<Lookup[]> {
    let rtn = this.http.get<Lookup[]>(this.baseUrl + "api/ProjectQuote/GetQuoteEngRequestStatusLookups");
    return rtn;
  }

  async sendEngineeringRequestEmail(requestObj) : Promise<any> {
    let response = await lastValueFrom(this.http.post(this.baseUrl + "api/ProjectQuote/SendEngRequestEmail", requestObj,
    {
      'headers': {
        'Content-Type' : 'application/json'
      }
    }));
    return response;
  }

  requestInformationProjectQuoteEngineeringRequest(engRequestId: number) : Observable<EngineeringRequest> {
    let rtn = this.http.post<EngineeringRequest>(this.baseUrl + `api/ProjectQuote/SendMoreInformationEngRequest/${engRequestId}`, {},
    {
      'headers': {
        'Content-Type' : 'application/json'
      }
    });
    return rtn;
  }

  async upsertProjectQuoteNetAdds(request: ProjectQuoteNetAdds) : Promise<ProjectQuoteNetAdds> {
    let response = await lastValueFrom(this.http.post<ProjectQuoteNetAdds>(this.baseUrl + "api/ProjectQuoteNetAdds", JSON.stringify(request),
    {
      'headers': {
        'Content-Type' : 'application/json'
      }
    }));
    return response;
  }

  getProjectQuoteNetAdds(projectQuoteId: number) : Observable<ProjectQuoteNetAdds> {
    let rtn = this.http.get<ProjectQuoteNetAdds>(this.baseUrl + "api/ProjectQuoteNetAdds/GetByProjectQuoteId/" + projectQuoteId);
    return rtn;
  }

  async deleteProjectQuoteNetAdds(netAdds: ProjectQuoteNetAddsDeleteRequest) : Promise<ProjectQuoteNetAddsDeleteResponse> {
    let response = await lastValueFrom(this.http.put<ProjectQuoteNetAddsDeleteResponse>(this.baseUrl + "api/ProjectQuoteNetAdds/delete", JSON.stringify(netAdds),
    {
      'headers': {
        'Content-Type' : 'application/json'
      }
    }));
    return response;
  }

  getQuoteStatusLookups() : Observable<Lookup[]> {
    let rtn = this.http.get<Lookup[]>(this.baseUrl + "api/ProjectQuote/GetQuoteStatusLookups");
    return rtn;
  }

  async generateQuotePDF(request: ProjectQuotePdfRequest) : Promise<any> {
    let response = await lastValueFrom(this.http.post(this.baseUrl + "api/ProjectQuote/GenerateQuotePdfs",JSON.stringify(request),
    {
      'headers': {
        'Content-Type' : 'application/json'
      }
    }));
    return response;
  }

  async generateQuotePartSummaryPDF(request: ProjectQuotePdfRequest) : Promise<any> {
    let response = await lastValueFrom(this.http.post(this.baseUrl + "api/ProjectQuote/GenerateQuotePartSummaryPdf",JSON.stringify(request),
    {
      'headers': {
        'Content-Type' : 'application/json'
      }
    }));
    return response;
  }

  async upsertProjectQuoteMultiplier(request: ProjectQuoteCatMultiplierUpsertRequest) : Promise<ProjectQuoteCatMultiplierUpsertResponse> {
    let response = await lastValueFrom(this.http.post<ProjectQuoteCatMultiplierUpsertResponse>(this.baseUrl + "api/ProjectQuoteCatMultiplier", JSON.stringify(request),
    {
      'headers': {
        'Content-Type' : 'application/json'
      }
    }));
    return response;
  }

  getProjectQuoteCatMultipliers (projectQuoteId: number) : Observable<ProjectQuoteCatMultiplier[]> {
    let response = this.http.get<ProjectQuoteCatMultiplier[]>(this.baseUrl + "api/ProjectQuoteCatMultiplier/GetByProjectQuoteId/" + projectQuoteId);
    return response;
  }
  
  async sendMultiplierRequestEmail(requestObj) : Promise<any> {
    let response = await lastValueFrom(this.http.post(this.baseUrl + "api/ProjectQuote/SendMultipliersRequestEmail", requestObj,
    {
      'headers': {
        'Content-Type' : 'application/json'
      }
    }));
    return response;
  }

  async upsertProjectQuoteDiscount(request: ProjectQuoteDiscountUpsertRequest) : Promise<ProjectQuoteDiscountUpsertResponse> {
    let response = await lastValueFrom(this.http.post<ProjectQuoteDiscountUpsertResponse>(this.baseUrl + "api/ProjectQuote/ProjectQuoteDiscountUpsert", JSON.stringify(request),
    {
      'headers': {
        'Content-Type' : 'application/json'
      }
    }));
    return response;
  }

  getProjectQuoteDiscountByQuoteId (projectQuoteId: number) : Observable<ProjectQuoteDiscount> {
    let response = this.http.get<ProjectQuoteDiscount>(this.baseUrl + "api/ProjectQuote/GetProjectQuoteDiscountByQuoteId/" + projectQuoteId);
    return response;
  }

  async sendQuoteDiscountRequestEmail(requestObj) : Promise<any> {
    let response = await lastValueFrom(this.http.post(this.baseUrl + "api/ProjectQuote/SendQuoteDiscountRequestEmail", requestObj,
    {
      'headers': {
        'Content-Type' : 'application/json'
      }
    }));
    return response;
  }

  async sendQuoteSubmittalEmail(requestObj) : Promise<any> {
    let response = await lastValueFrom(this.http.post(this.baseUrl + "api/ProjectQuote/SendQuoteSubmittalEmail", requestObj,
    {
      'headers': {
        'Content-Type' : 'application/json'
      }
    }));
    return response;
  }

  async upsertProjectQuoteNote(request: ProjectQuoteNoteUpsertRequest) : Promise<ProjectQuoteNoteUpsertResponse> {
    let response = await lastValueFrom(this.http.post<ProjectQuoteNoteUpsertResponse>(this.baseUrl + "api/ProjectQuote/UpsertProjectQuoteNote", JSON.stringify(request),
    {
      'headers': {
        'Content-Type' : 'application/json'
      }
    }));
    return response;
  }

  async getProjectQuoteNotes (projectQuoteId: number) : Promise<ProjectQuoteNote[]> {
    let response = await lastValueFrom(this.http.get<ProjectQuoteNote[]>(this.baseUrl + "api/ProjectQuote/GetQuoteNotesByQuoteId/" + projectQuoteId));
    return response;
  }

  getCodeStringData(projectScheduleLineItemId: number) : Observable<any | null> {
    let rtn = this.http.get<any>(this.baseUrl + "api/Pricing/GetCodeStringData/" + projectScheduleLineItemId, {
      'headers': {
        'Content-Type' : 'application/json'
      }  
    });
    return rtn;
  }

  sendUploadCSV(fileName: string, fileContents: string, uploadType?: number) {
    console.log("Uploading...");
    console.log("File " + fileName + " -> " +  fileContents);
    console.log("Upload Type -> " + uploadType);
    console.log(fileContents);
    //fileContents = fileContents.replaceAll("\"","\\\'");
    console.log(fileContents);
    return this.http.post(this.baseUrl + "api/ExcelUploader/Upload/" + uploadType, JSON.stringify(fileContents),
    {
      'headers': {
        'Content-Type' : 'application/json'
      }
    }).subscribe(() => console.log(
      "ran"
    ));
  }
  async getSubmittalReport(request: SubmittalReportRequest) : Promise<any> {
    let response = await lastValueFrom(this.http.post(this.baseUrl + "api/project/GenerateSubmittalPdfs",request,
    {
      'headers': {
        'Content-Type' : 'application/json'
      }
    }));
    return response;
  }
  async getProductTypeLookup() : Promise<SelectLookup[]> {
    
    let response = (await lastValueFrom(this.http.get(this.baseUrl + "api/project/GetProductTypeLookups",
      {
        'headers': {
          'Content-Type' : 'application/json'
        }
      }))) as SelectLookup[];
      return response;

  }
  async toPromise<T>(observable: Observable<T>): Promise<T> {
    return lastValueFrom(observable);
  }

  getFilterPressureDropParameters(request:FilterPressureDropDataRequest) : Observable<FilterPressureDropDataResponse> {
    var rtn = this.http.post<FilterPressureDropDataResponse>(this.baseUrl + "api/FilterPressureDrop/GetFilterPressureDropParameters", JSON.stringify(request),
    {
      'headers': {
        'Content-Type' : 'application/json'
      }
    });
    return rtn;
  }

  getCoilConfigurationViewModels(): CoilConfigurationViewModel[] {
    return [
      { "CoilConfigurationId": 1, "Name": "2-Pipe System" },
      { "CoilConfigurationId": 2, "Name": "4-Pipe System" }
    ];
 }
//  cns: no longer used
//  getUnitSizeViewModels(): UnitSizeViewModel[] {
//   return [
//     { "UnitSizeId": 1, "Name": "03" },
//     { "UnitSizeId": 1, "Name": "04" },
//     { "UnitSizeId": 1, "Name": "05" },
//   ];
//  }
 getConfigurationTypeViewModels(): ConfigurationTypeViewModel[] {
  return [
    { "ConfigurationTypeId": 1, "Name": "Chilled Water" },
    { "ConfigurationTypeId": 2, "Name": "Hot Water" },
    { "ConfigurationTypeId": 3, "Name": "Changeover" }
  ];
 }
//  getUnitVoltageViewModels(): UnitVoltageViewModel[] {
//   return [
//     { "UnitVoltageId": 1, "Name": "120V-1Ph-60Hz" },
//     { "UnitVoltageId": 2, "Name": "208V-1Ph-60Hz" },
//     { "UnitVoltageId": 3, "Name": "230V-1Ph-60Hz" },
//     { "UnitVoltageId": 4, "Name": "277V-1Ph-60Hz" },
//   ];
// }
// AirMotorTypeId?: number;
// AirFanSpeedId?: number;
// AirSelectById?: number;
// AirCoilConnectionId?: number;
getAirMotorTypeViewModels(): AirMotorTypeViewModel[] {
  return [
    { "AirMotorTypeId": 1, "Name": "PSC" },
    { "AirMotorTypeId": 2, "Name": "ECM" }
  ];
}
getAirFanSpeedViewModels(): AirFanSpeedViewModel[] {
  return [
    { "AirFanSpeedId": 1, "Name": "Low" },
    { "AirFanSpeedId": 2, "Name": "Medium" },
    { "AirFanSpeedId": 3, "Name": "High" }
  ];
}
getAirSelectByViewModels(): AirSelectByViewModel[] {
  return [
    //cns: removing option for now
    //{ "AirSelectById": 1, "Name": "Unit Airflow" },
    { "AirSelectById": 2, "Name": "ESP" }
  ];
}
getAirCoilConnectionViewModels(): AirCoilConnectionViewModel[] {
  return [
    { "AirCoilConnectionId": 1, "Name": "Left" },
    { "AirCoilConnectionId": 2, "Name": "Right" }
  ];
}

// CoolCoilRowsConfigurationId: number;  //select from drop down
// CoolSelectionMethodId: number;  //select from drop down
// CoolFilterMethodId: number; //select from drop down
// CoolFluidTypeId: number; //select from drop down
// getCoolCoilRowsConfigurationViewModels(): CoolCoilRowsConfigurationViewModel[] {
//   return [
//     { "CoolCoilRowsConfigurationId": 1, "Name": "3" },
//     { "CoolCoilRowsConfigurationId": 2, "Name": "4" }
//   ];
// }
getCoolSelectionMethodViewModels(): CoolSelectionMethodViewModel[] {
  return [
    { "CoolSelectionMethodId": 1, "Name": "Fluid Flow" },
    { "CoolSelectionMethodId": 2, "Name": "Leaving Fluid Temp" }
  ];
};
getCoolFilterMethodViewModels(): CoolFilterMethodViewModel[] {
  return [
    { "CoolFilterMethodId": 1, "Name": "None" },
    { "CoolFilterMethodId": 2, "Name": "LAT" },
    { "CoolFilterMethodId": 3, "Name": "Capacity" }
  ];
}
getCoolFluidTypeViewModels(): CoolFluidTypeViewModel[] {
  return [
    { "CoolFluidTypeId": 40, "Name": "Water" },
    { "CoolFluidTypeId": 41, "Name": "Ethylene" },
    { "CoolFluidTypeId": 42, "Name": "Propylene" }
  ];
}

getHeatCoilRowsConfigurationViewModels(): HeatCoilRowsConfigurationViewModel[] {
  return [
    { "HeatCoilRowsConfigurationId": 1, "Name": "3" },
    { "HeatCoilRowsConfigurationId": 2, "Name": "4" }
  ];
}
getHeatSelectionMethodViewModels(): HeatSelectionMethodViewModel[] {
  return [
    { "HeatSelectionMethodId": 1, "Name": "Fluid Flow" },
    { "HeatSelectionMethodId": 2, "Name": "Leaving Fluid Temp" }
  ];
}
getHeatFilterMethodViewModels(): HeatFilterMethodViewModel[] {
  return [
    { "HeatFilterMethodId": 1, "Name": "None" },
    { "HeatFilterMethodId": 2, "Name": "LAT" },
    { "HeatFilterMethodId": 3, "Name": "Capacity" }
  ];
}
getHeatFluidTypeViewModels(): HeatFluidTypeViewModel[] {
  return [
    { "HeatFluidTypeId": 40, "Name": "Water" },
    { "HeatFluidTypeId": 41, "Name": "Ethylene" },
    { "HeatFluidTypeId": 42, "Name": "Propylene" }
  ];
}
getEHeatCapacityViewModels(): EHeatCapacityViewModel[] {
  return [
    { "EHeatCapacityId": 1, "Name": "3" },
    { "EHeatCapacityId": 2, "Name": "4" }
  ];
}
toggleScheduleLineItemStatus(projectScheduleId: number) : Observable<ToggleStatusResponse> {
  let requestUrl = this.baseUrl + "api/ProjectScheduleLineItem/ToggleStatus/" + projectScheduleId;
  console.log("requestURL =>", requestUrl);

  let rtn = this.http.put<ToggleStatusResponse>(requestUrl,{});
  console.log(rtn);
  return rtn;
}
getResetPasswordViewModel(userId: number) : Observable<ResetPasswordViewModel> {
  
  let response = this.http.get<ResetPasswordViewModel>(this.baseUrl + "api/appUser/GetResetPasswordVM/" + userId);
  return response;

}
createMultiplierRequest(request: CreateMultiplierRequestDto) : Observable<AppDtoResponse | null> {
  let response = this.http.post<AppDtoResponse>(this.baseUrl + "api/ProjectQuote/CreateMultiplierRequest", JSON.stringify(request),
  {
    'headers': {
      'Content-Type' : 'application/json'
    }
  });
  return response;
}
getProjectQuoteMultiplierRequests(quoteId: number) : Observable<ProjectQuoteMultiplierRequest[] | null> {
    var result = this.http.get<ProjectQuoteMultiplierRequest[] | null>(this.baseUrl + "api/ProjectQuote/GetMultiplierRequests/" + quoteId);
    return result;
}
getQuoteMultiplierRequestReviewers(quoteId: number) : Observable<number[]> {
    var result = this.http.get<number[]>(this.baseUrl + "api/ProjectQuoteCatMultiplier/GetQuoteMultiplierRequestReviewers/" + quoteId);
    return result;
}
upsertNotification(request: NotificationDTO) : Observable<Notification | null> {
  let response = this.http.post<Notification>(this.baseUrl + "api/Notification", JSON.stringify(request),
  {
    'headers': {
      'Content-Type' : 'application/json'
    }
  });
  return response;
}
upsertOrderRequestNotification(projectQuoteId: number) : Observable<Notification | null> {
  let response = this.http.post<Notification>(this.baseUrl + `api/Notification/UpsertOrderRequestNotification/${projectQuoteId}`,
  {
    'headers': {
      'Content-Type' : 'application/json'
    }
  });
  return response;
}
markNotificationRead(notificationId: number) : Observable<boolean | null> {
  let response = this.http.post<boolean>(this.baseUrl + `api/Notification/MarkNotificationRead/${notificationId}`,
  {
    'headers': {
      'Content-Type' : 'application/json'
    }
  }); 
  return response;
}
GetUserNotificationCount() : Observable<number | null> {
    let requestId = uuidv7();
    var result = this.http.get<number | null>(this.baseUrl + "api/Notifications/getUserNotificationCount");
    return result;
}
// UpdateProjectQuoteDistributorMultiplier(projectQuoteId: number, distributorMultiplier: number) : Observable<boolean> {
//   let requestUrl = this.baseUrl + "api/ProjectQuote/UpdateProjectQuoteDistributorMultiplier/" + projectQuoteId + "/" + distributorMultiplier;
//   console.log("requestURL =>", requestUrl);

//   let rtn = this.http.put<boolean>(requestUrl,{});
//   console.log(rtn);
//   return rtn;
// }
// deleteProjectQuoteCatMultiplier(projectQuoteCatMultiplierId: number): Observable<boolean> {
//   const requestUrl = `${this.baseUrl}api/ProjectQuoteCatMultiplier/${projectQuoteCatMultiplierId}`;
//   console.log("DELETE url =>", requestUrl);

//   return this.http.delete<boolean>(requestUrl);
// }
setCategoryMultiplierActiveStatus(projectQuoteCatMultiplierId: number, active: boolean): Observable<AppDtoResponse> {
    let response = this.http.put<AppDtoResponse>(this.baseUrl + `api/ProjectQuoteCatMultiplier/SetActiveStatus/${projectQuoteCatMultiplierId}/${active}`,
  {
    'headers': {
      'Content-Type' : 'application/json'
    }
  }); 
  return response;
}
ExtendQuoteExpirationDate(projectQuoteId: number) : Observable<AppDtoResponse | null> {
  let response = this.http.put<AppDtoResponse>(this.baseUrl + `api/ProjectQuote/ExtendQuoteExpiration/${projectQuoteId}`,
  {
    'headers': {
      'Content-Type' : 'application/json'
    }
  }); 
  return response;
}
CloseProjectQuote(closeQuoteRequest: CloseQuoteRequest) : Observable<AppDtoResponse> {
  let response = this.http.post<AppDtoResponse>(this.baseUrl + `api/ProjectQuote/CloseQuote`, JSON.stringify(closeQuoteRequest),
  {
    'headers': {
      'Content-Type' : 'application/json'
    }
  }); 
  return response;
}
ReviewQuoteMultiplierRequest(request: ReviewMultiplierRequest) : Observable<ReviewMultiplierRequestResponse | null> {
  let response = this.http.post<ReviewMultiplierRequestResponse>(this.baseUrl + `api/ProjectQuote/ReviewMultiplierRequest`, JSON.stringify(request),
  {
    'headers': {
      'Content-Type' : 'application/json'
    }
  }); 
  return response;
}
ResetApprovedMultiplier(projectQuoteCatMultiplierId: number) : Observable<AppDtoResponse | null> {
  let response = this.http.put<AppDtoResponse>(this.baseUrl + `api/ProjectQuoteCatMultiplier/ResetApprovedMultiplier/${projectQuoteCatMultiplierId}`,
  {
    'headers': {
      'Content-Type' : 'application/json'
    }
  }); 
  return response;
}
calculateFreightEstimate(request: FreightEstimateRequest) : Observable<FreightEstimateResponse | null> {
  let response = this.http.post<FreightEstimateResponse>(this.baseUrl + `api/ProjectQuote/CalculateFreightEstimate`, JSON.stringify(request),
  {
    'headers': {
      'Content-Type' : 'application/json'
    }
  });
  return response;
}
requestProjectQuote(request: ProjectQuoteRequestRequest) : Observable<ProjectQuoteRequestResponse | null> {
  let response = this.http.post<ProjectQuoteRequestResponse>(this.baseUrl + `api/ProjectQuote/RequestProjectQuote`, JSON.stringify(request),
  {
    'headers': {
      'Content-Type' : 'application/json'
    }  });
  return response;
}
upsertQuoteRequestNotification(projectScheduleId: number)  : Observable<AppDtoResponse | null> {
  let response = this.http.post<AppDtoResponse>(this.baseUrl + `api/Notification/UpsertQuoteRequestNotification/${projectScheduleId}`, null,
  {
    'headers': {
      'Content-Type' : 'application/json'
    }  });
  return response;
}
sendRequestMoreInfoEmail(request: MoreInfoEmailRequest) : Observable<AppDtoResponse | null> {
  let response = this.http.post<AppDtoResponse>(this.baseUrl + `api/Notification/SendRequestMoreInfoEmail`, JSON.stringify(request),
  {
    'headers': {
      'Content-Type' : 'application/json'
    }  });
  return response;
}
notifyProjectSalesRep(projectId: number, parentRepUserId: number) : Observable<AppDtoResponse | null> {
  let response = this.http.post<AppDtoResponse>(this.baseUrl + `api/Notification/UpsertEngineerProjectCreatedNotification/${projectId}/${parentRepUserId}`, null,
  {
    'headers': {
      'Content-Type' : 'application/json'
    }  });
  return response;
}
sendProjectCreatedEmail(projectId: number) : Observable<AppDtoResponse | null> {
  let response = this.http.post<AppDtoResponse>(this.baseUrl + `api/Project/SendProjectCreatedEmail/${projectId}`, null,
  {
    'headers': {
      'Content-Type' : 'application/json'
    }  });
  return response;
}
getByType(entityType: number, entityId: number) : Observable<Notification[] | null> {
  let response = this.http.get<Notification[]>(this.baseUrl + `api/Notification/GetByType/${entityType}/${entityId}`,
  {
    'headers': {
      'Content-Type' : 'application/json'
    }  });
  return response;
}
async getCompanyByProjectBuildingSalesRegion(locationId: number) : Promise<CompanyRegionsByCounty | null> {
  let response = await lastValueFrom(this.http.get<CompanyRegionsByCounty>(this.baseUrl + `api/ProjectQuote/GetCompanyByProjectBuildingSalesRegion/${locationId}`,
  {
    'headers': {
      'Content-Type' : 'application/json'
    }  }));
  return response;
}
notifyProjectLocationSalesRegion(request: NotifyProjectLocationSalesRegionRequest) : Observable<AppDtoResponse | null> {
  let response = this.http.post<AppDtoResponse>(this.baseUrl + `api/ProjectQuote/NotifyProjectBuildingLocationSalesRegion`, JSON.stringify(request),
  {
    'headers': {
      'Content-Type' : 'application/json'
    }  });
  return response;
}
sendCompanyMissingAdminManagerRoleEmail(companyId: number) : Observable<AppDtoResponse | null> {
  let response = this.http.post<AppDtoResponse>(this.baseUrl + `api/ProjectQuote/SendCompanyMissingRepAdminManagerEmail/${companyId}`, null,
  {
    'headers': {
      'Content-Type' : 'application/json'
    }  });
  return response;
}
getCompanyCounties(companyId: number) : Observable<CompanyCounties | null> {
  let response = this.http.get<CompanyCounties>(this.baseUrl + `api/Company/GetCountiesByCompanyId/${companyId}`,
  {
    'headers': {
      'Content-Type' : 'application/json'
    }  });
  return response;
}
getAllCompanyCounties() : Observable<CompanyCounties[] | null> {
  let response = this.http.get<CompanyCounties[]>(this.baseUrl + `api/Company/GetAllCompanyCounties`,
  {
    'headers': {
      'Content-Type' : 'application/json'
    }  });
  return response;
}
getCounties() : Observable<County[] | null> {
  let response = this.http.get<County[]>(this.baseUrl + `api/Location/GetCounties`,
  {
    'headers': {
      'Content-Type' : 'application/json'
    }  });
  return response;
}
getCountiesByState(state: string) : Observable<County[] | null> {
  let response = this.http.get<County[]>(this.baseUrl + `api/Location/GetCountiesByState/${state}`,
  {
    'headers': {
      'Content-Type' : 'application/json'
    }  });
  return response;
}
getStatesProvinces() : Observable<StatesProvinces[] | null> {
  let response = this.http.get<StatesProvinces[]>(this.baseUrl + `api/Location/states`,
  {
    'headers': {
      'Content-Type' : 'application/json'
    }  });
  return response;
}
upsertCompanyCounty(request: CompanyCountyUpsertRequest) : Observable<CompanyCountyUpsertResponse | null> {
  let response = this.http.put<CompanyCountyUpsertResponse>(this.baseUrl + `api/Company/UpsertCompanyCounties`, JSON.stringify(request),
  {
    'headers': {
      'Content-Type' : 'application/json'
    }  });
  return response;
}
async createReleaseNotes(request: ReleaseNotesUpsertRequest) : Promise<ReleaseNotesUpsertResponse> {
  let response = lastValueFrom(await this.http.post<ReleaseNotesUpsertResponse>(this.baseUrl + `api/ReleaseNotes/`, JSON.stringify(request),
  {
    'headers': {
      'Content-Type' : 'application/json'
    }  }))
  return response;
}
async updateReleaseNotes(request: ReleaseNotesUpsertRequest) : Promise<ReleaseNotesUpsertResponse> {
  let response = lastValueFrom(await this.http.put<ReleaseNotesUpsertResponse>(this.baseUrl + `api/ReleaseNotes/`, JSON.stringify(request),
  {
    'headers': {
      'Content-Type' : 'application/json'
    }  }))
  return response;
}
async deleteReleaseNote(request: ReleaseNotesUpsertRequest) : Promise<ReleaseNotesUpsertResponse> {
  let response = lastValueFrom(await this.http.delete<ReleaseNotesUpsertResponse>(this.baseUrl + `api/ReleaseNotes/`, {
    'headers': {
      'Content-Type' : 'application/json'
    },
    body: JSON.stringify(request)
  }));
  return response;
}
getReleaseNotes() : Observable<ReleaseNote[] | null> {
  let response = this.http.get<ReleaseNote[]>(this.baseUrl + `api/ReleaseNotes/`,
  {
    'headers': {
      'Content-Type' : 'application/json'
    }  });
  return response;
}
getReleaseNoteById(releaseId: string) : Observable<ReleaseNote | null> {
  let response = this.http.get<ReleaseNote>(this.baseUrl + `api/ReleaseNotes/${releaseId}`,
  {
    'headers': {
      'Content-Type' : 'application/json'
    }  });
  return response;
}
getReleaseNotesForUser(userId: number) : Observable<ReleaseNote | null> {
  let response = this.http.get<ReleaseNote>(this.baseUrl + `api/ReleaseNotes/GetReleaseNotesForUser/${userId}`,
  {
    'headers': {
      'Content-Type' : 'application/json'
    }  });
  return response;
}
async dismissReleaseNotesAlert(request: ReleaseNotesDismissRequest) {
  let reposnse = lastValueFrom(await this.http.post(this.baseUrl + `api/ReleaseNotes/DismissReleaseNotesAlert/`, JSON.stringify(request),
  {
    'headers': {
      'Content-Type' : 'application/json'
    }  }));
  return reposnse;
}
// renderAppResponseToasts(appResponse : AppDtoResponse): void {
//      let notificationTypeEnum: NotificationTypeEnum = 
//       appResponse.ResponseType == ResponseTypeEnum.Success ? NotificationTypeEnum.Success : 
//       appResponse.ResponseType == ResponseTypeEnum.Warning ? NotificationTypeEnum.Warning : 
//       NotificationTypeEnum.Error;
//       var message = this.ListToString(appResponse.messages);
//       this.notificationService.PresentTypedToast(message, notificationTypeEnum)
  
// }
// ListToString(list: string[]){
//   if(list.length == 1)
//     return list[0];
//   var message = "";           
//   list.forEach(element => {
//     message += `• ${element}\n`
//   });
//   return message;
// }
}
